import WebFont from 'webfontloader';
import PageUtils from '../modules/pageutils';
import Choices from 'choices.js';
import Hamburger from '../modules/hamburger'; 
import initializeGlider from '../modules/initialize-glider';
import HomeNavigation from '../modules/home-navigation';
import MegaMenu from '../modules/megamenu';
import MediaSlider from '../modules/media-slider';
import ShowList from '../modules/show-list';
// import InitalizeVideo from '../modules/initialize-video';
import Storelocator from '../modules/storelocator'; 
import Timeline from '../modules/timeline'; 
import FormObject from '../modules/form-object'; 
import VideoSingle from '../modules/video-single';
import Support from '../modules/support';
import Lightbox from '../modules/lightbox';
import ShowMoreInfoTable from '../modules/show-moreinfotable';
import Rellax from 'rellax';
import ScrollOut from 'scroll-out';
import navigation from '../modules/navigation';
import tableForm from '../modules/tableForm';
import ricevo from '../modules/ricevo';
import bannerApp from '../modules/bannerApp';

export default {
  init() {
    // JavaScript to be fired on all pages
    WebFont.load({
        google: {
            families: ['Manrope:400,500,600,700,800'],
        },
        timeout: 4000,
    });
  },
  finalize() {
    // Set Utilities
    PageUtils();
    HomeNavigation();
    MegaMenu();
    MediaSlider();
    ShowList();
    Storelocator();
    FormObject();
    VideoSingle();
    Timeline();
    Support();
    Lightbox();
    ShowMoreInfoTable();
    navigation();
    tableForm();
    ricevo();
    bannerApp();

    /*Hamburger*/
    let allHtml = document.querySelector('html'); 
    Hamburger.register('body',{
        onOpen: () => {
          allHtml.style.overflow = 'hidden';
        },
        onClose: () => {
          allHtml.style.overflow = 'auto';
        },
    });
 
    //Lettura viewport
    let vw = document.body.clientWidth * 0.01;
    let vh = window.screen.availHeight * 0.01;
    document.documentElement.style.setProperty('--vw', `${vw}px`);
    document.documentElement.style.setProperty('--vh', `${vh}px`);

    const is_touch_enabled = () => { 
      return ( 'ontouchstart' in window ) ||  
            ( navigator.maxTouchPoints > 0 ) ||  
            ( navigator.msMaxTouchPoints > 0 ); 
    }

    if (!is_touch_enabled()) {
      document.body.classList.toggle('is-not-touchable');
    }

    /*Style select menu page*/
    const archiveFilters = document.querySelectorAll('.js-archive-filter');
    archiveFilters.forEach(element => {
      new Choices(element, {
        searchEnabled: false,
        itemSelectText: '',
        shouldSort: false,
      });
      element.addEventListener('choice', sel => {
        window.location.href = sel.detail.choice.value;
      })
    });

    initializeGlider();


    //Parallax Blocco Immagine Testo
    const textImageRellax = document.querySelector('.textImageRellax'); 
    if((!(vw <= 768 && is_touch_enabled())) && (textImageRellax )){
      new Rellax('.rellax-down', {
        speed: -1,
        center: true,
        wrapper: null,
        round: true,
        vertical: true,
        horizontal: false,
      });
    }

    //Media Slider animation on scroll
    const mediaSliderMedia = document.querySelector('.animation-onScroll--Media');
    if(mediaSliderMedia){
      ScrollOut({ 
        targets:'.animation-onScroll--Media', 
        threshold: 0.1,
        onShown(mediaSliderMedia) {
          mediaSliderMedia.classList.add("slide-in-left");
        }
      });
    }

  }, //fine finalized
};
